<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-history'"></top-line>
    <el-row class="pagebody">
      <!-- 搜索过滤栏 -->
      <el-card shadow="never" class="filter-bar">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="100px">
          <el-row>
            <!-- 搜索项 -->
            <el-col :span="6">
              <el-form-item label="登录账号" prop="account">
                <el-input v-model="searchForm.account" placeholder="请输入账号" style="width: 175px" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户名称" prop="username">
                <el-input v-model="searchForm.username" placeholder="请输入姓名" style="width: 175px" clearable />
              </el-form-item>
            </el-col>
           
            <el-col :span="6">
              <el-form-item label="登录IP" prop="ipaddr">
                <el-input v-model="searchForm.ipaddr" placeholder="请输入IP" style="width: 175px" clearable />
              </el-form-item>
            </el-col>
            <!-- 操作按钮 -->
            <el-col :span="6" style="text-align: right; padding-top: 10px;">
              <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
              <el-button type="info" icon="el-icon-refresh-left" size="small" @click="handleReset" style="margin-left: 8px">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%">
        <el-table-column prop="account" label="登录账号" min-width="140" show-overflow-tooltip />
        <el-table-column prop="username" label="用户名称" min-width="120" show-overflow-tooltip />
        <!-- <el-table-column prop="user_id" label="用户ID" min-width="140" show-overflow-tooltip /> -->
        <el-table-column label="登录结果" width="100">
          <template v-slot="scope">
            <el-tag :type="scope.row.login_result === 1 ? 'success' : 'danger'">
              {{ scope.row.login_result === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="fail_reason" label="失败原因" min-width="160" show-overflow-tooltip />
        <el-table-column prop="login_type" label="登录方式" :formatter="formatLoginType" width="100" />
        <el-table-column prop="ipaddr" label="登录IP" min-width="130" />
        <el-table-column prop="login_location" label="登录地点" min-width="140" />
        <el-table-column prop="browser" label="浏览器" min-width="130" />
        <el-table-column prop="os" label="操作系统" min-width="130" />
        <el-table-column prop="create_time" label="登录时间" width="170">
          <template #default="{ row }">
            {{ formatDateTime(row.create_time) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row type="flex" justify="left" style="margin-top: 15px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.pageSizeList"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";
import util from '@/libs/util.js';
import { MessageBox } from 'element-ui';

export default {
  name: "login-log",
  components: {
    topLine,
  },
  mounted() {
    this.loadParams();
  },
  data() {
    return {
      pageTitle: "登录日志",
      tableDataApi: '/api-30216/api/logs/login', // 假设登录日志接口
      searchForm: {
        account: '',
        username: '',
        user_id: '',
        login_result: '', // 0: 失败, 1: 成功
        ipaddr: '',
        login_location: '',
        browser: '',
        os: '',
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
      },
      pagination: {
        page: parseInt(this.$route.query.page) || 1,
        pageSize: parseInt(this.$route.query.pageSize) || 10,
        total: 0,
        pageSizeList: [10, 20, 50, 100]
      },
      tableData: []
    };
  },
  methods: {
    formatDateTime(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const Y = date.getFullYear() + '-';
      const M = (date.getMonth() + 1).toString().padStart(2, '0') + '-';
      const D = date.getDate().toString().padStart(2, '0') + ' ';
      const h = date.getHours().toString().padStart(2, '0') + ':';
      const m = date.getMinutes().toString().padStart(2, '0') + ':';
      const s = date.getSeconds().toString().padStart(2, '0');
      return Y + M + D + h + m + s;
    },

    // 格式化登录方式（示例：1-密码 ,2-短信验证码，3-LDAP等）
    formatLoginType(row, column, value) {
      const map = {
        1: '密码',
        2: '短信验证码',
        3: 'LDAP'
      };
      return map[value] || '未知';
    },

    loadParams() {
      const query = this.$route.query;
      if (query.page) this.pagination.page = parseInt(query.page, 10);
      if (query.pageSize) this.pagination.pageSize = parseInt(query.pageSize, 10);
      this.getTableData();
    },

    handleReset() {
      this.searchForm = {
        account: '',
        username: '',
        user_id: '',
        login_result: '',
        ipaddr: '',
        login_location: '',
        browser: '',
        os: '',
        page: 1,
        pageSize: this.pagination.pageSize
      };
      this.getTableData();
    },

    handleSearch() {
      this.pagination.page = 1;
      this.getTableData();
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.getTableData();
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.getTableData();
    },

    getTableData() {
      const params = { ...this.searchForm };
      params.page = this.pagination.page;
      params.pageSize = this.pagination.pageSize;

      this.$axios.get(this.tableDataApi, { params })
        .then(response => {
          const data = response.data || [];
          this.tableData = Array.isArray(data) ? data : data;
          this.pagination.total = response.total || data.total || 0;
        })
        .catch(err => {
          console.error('获取登录日志失败', err);
          this.$message.error('数据加载失败');
        });
    },
  
  }
};
</script>

<style scoped lang="scss">
.pagebody {
  margin: 20px;
}
.filter-bar {
  margin-bottom: 15px;
}
</style>